exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-e1cb1976] .collapse_1 .van-cell{background-color:#f6f6f6}", ""]);

// exports
